import createRoute          from '@widesk-ui/tools/createRoute';
import PartnershipTypeModel from '@models/website/PartnershipTypeModel';

const route = createRoute.dashboardFromModel(
	PartnershipTypeModel,
	'PartnershipTypeDashboard',
	{
		pathPrefix: '/configuration',
	}
);
export default route;
